<template>
    <Button :label="$t('view_realization')" icon="pi pi-info-circle" class="p-button-help p-button-sm mr-2" @click="onShowRealizationModal" />

    <CustomSidebar v-model:visible="showRealizationModal" position="bottom" :dismissable="false" :title="$t('view_realization')" class="p-1" :blocked="blocked">
        <template #actions-left>
            <!-- <Button icon="pi pi-save" class="p-button-sm p-button-success mr-1" :label="$t('assign_to_driver')" @click="save()"></Button> -->
            <Button :icon="showInfo ? 'pi pi-chevron-left' : 'pi pi-chevron-right' " class="p-button-sm p-button-help ml-3" :label="showInfo ? $t('hide_info') : $t('show_info')" @click="onShowHideInfo" ></Button>
        </template>

        <div class="flex" style="width:calc(100% - 2rem)">
            <div class="col-4 md-4 p-fluid" v-if="showInfo">
                <ScrollPanel style="width:100%;height:80vh">
                    <ModalDataShipment :data="orderData" v-if="orderData" :showDetailed="true"/>
                </ScrollPanel>
            </div>
            <Divider layout="vertical" v-if="showInfo"/>
            <div :class="(showInfo ? 'col-8 md-4 p-fluid' : 'col-12 md-4 p-fluid' )">

                <ScrollPanel style="width:100%;height: 80vh">
                    <DataTable :loading="!orderData" :value="orderData ? orderData.Details : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                        <Column field="Item_No" :header="$t('item_no')" key="Item_No" style="width:10%">  
                        </Column>
                        <Column field="Material_Name" header="Material" key="Material_Name">
                        </Column>
                        <Column field="Qty" :header="$t('qty')" key="Active" style="width:15%">
                            <template #body="slotProps">
                                {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="Real_Qty" :header="$t('total_real_qty')" key="Active" style="width:15%">
                            <template #body="slotProps">
                                {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="UOM" header="UOM" key="Active" style="width:10%">
                        </Column>
                    </DataTable>

                    <Divider />

                    <DataTable :loading="!realData" :value="realData ? realData: null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                        <Column field="Item_No" :header="$t('shipment_item_no')" key="Item_No">  
                        </Column>
                        <Column field="Order_Item_No" :header="$t('order_item_no')" key="Item_No">  
                        </Column>
                        <Column field="Ref_No" :header="$t('ref_no')" key="Item_No">  
                        </Column>
                        <Column field="SAP_No" :header="$t('sap_no')" key="Item_No">  
                        </Column>
                        <Column field="SAP_Item_No" :header="$t('sap_item_no')" key="Item_No">  
                        </Column>
                        <Column field="STO_No" :header="$t('sto_no')" key="Item_No">  
                        </Column>
                        <Column field="STO_Item_No" :header="$t('sto_item_no')" key="Item_No">  
                        </Column>
                        <Column field="Order_No" :header="$t('order_no')" key="Item_No">  
                        </Column>
                        <Column field="Material_Code" :header="$t('material')" key="Item_No">  
                        </Column>
                        <Column field="Qty" :header="$t('real_qty')" key="Item_No">  
                        </Column>
                        <Column field="Return_Qty" :header="$t('return_qty')" key="Item_No">  
                        </Column>
                        <Column field="UOM" header="UOM" key="Active" style="width:10%">
                        </Column>
                        <Column field="Report_Date" :header="$t('report_date')" key="Active" style="width:10%">
                            <template #body="slotProps">
                                {{this.$formatDate(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="Registration_In_Date" :header="$t('registration_in_date')" key="Active" style="width:10%">
                            <template #body="slotProps">
                                {{this.$formatDateTime(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="Registration_Out_Date" :header="$t('registration_out_date')" key="Active" style="width:10%">
                            <template #body="slotProps">
                                {{this.$formatDateTime(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="Cancel" :header="$t('cancelled')" key="Item_No">  
                        </Column>
                    </DataTable>
                </ScrollPanel>
            </div>
        </div>
    </CustomSidebar>    
</template>
<script>
    import ModalDataShipment from '../Helper/_ModalDataShipment.vue'
    import ShowShipment from '../Helper/_ShowShipment.vue'

    export default{
        components: {
            'ModalDataShipment': ModalDataShipment,
            'ShowShipment': ShowShipment
        },
        emits:['close'],
        props:{
            data: {
                type: Object,
                default: null
            },
        },
        data(){
            return{
                showRealizationModal: false,
                isIndividual: false,
                isCollective: false,
                isRelation: false,
                driverModels: [],
                orderData: null,
                realData: null,
                driverModel: null,
                dataUrl: "shipment/",
                blocked:false,
                transporter:"",
                location: "",
                showInfo: true
            }
        },
        mounted(){
            
        },
        methods:{
            reset(){
                this.orderData = null;
                this.driverModel = null;
                this.driverTruckModel = null;
                this.driverModels = [];
                this.isRelation = false;
                this.isIndividual = false;
                this.isCollective = false;
                this.transporter = "";
                this.location = "";
            },
            onShowRealizationModal(){
                this.reset();
            
                this.blocked = true;
                this.showRealizationModal = true;

                var self = this;

                this.$axios.get(this.$API_URL + this.dataUrl + this.data.Id + "/" + this.$FORM_MODE_EDIT)
                    .then((response) => {
                        if (response.data.success) {
                            self.orderData = response.data.data.header;
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            //self.showAssignModal = false;
                        }
                        self.blocked = false;
                        
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });

                this.$axios.get(this.$API_URL + this.dataUrl + "realization" + "/" + this.data.Id)
                    .then((response) => {
                        if (response.data.success) {
                            self.realData = response.data.data;

                            // if(self.orderData.Shipment_Type_Category == this.$SHIPMENT_TYPE_CATEGORY.INDIVIDUAL)
                            //     this.addDetail();

                            // self.isRelation = self.orderData.Is_Relation;
                            // self.isIndividual = self.orderData.Shipment_Type_Category == this.$SHIPMENT_TYPE_CATEGORY.INDIVIDUAL;
                            // self.isCollective = self.orderData.Shipment_Type_Category == this.$SHIPMENT_TYPE_CATEGORY.COLLECTIVE;
                            // self.transporter = self.orderData.Transporter_Code;
                            // self.location = self.orderData.Warehouse_Location_Code;
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            //self.showAssignModal = false;
                        }
                        self.blocked = false;
                        
                    })
                    .catch(function (err) {
                        console.log(err);
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });
            },
            subTotalQty(dataArray){
                if(!dataArray) return 0;

                var sumQty = dataArray
                                .reduce(function(tot, arr) {
                                    return tot + (arr.Qty ? arr.Qty : 0);
                                },0);   

                return sumQty;
            },
            onShowHideInfo(){
                this.showInfo = !this.showInfo;
            }

            // addDetail() {
            //     var newDetail = this.driverModel;
            //     newDetail.mode = this.$FORM_MODE_CREATE;
            //     var det = { ...newDetail };

            //     this.driverModels.push(det);
            // },
            // deleteDetail(event) {
            //     if (event) {
            //         var detail = this.driverModels[event.index];

            //         if (detail.mode == this.$FORM_MODE_CREATE) this.driverModels.splice(this.driverModels.indexOf(detail), 1);
            //         else detail.mode = this.$FORM_MODE_DELETE;
            //     }
            // },
        },
        computed:{
            assignEditDriverModel(){
                return {driverModel: this.driverModel, driverModels: this.driverModels};
            }
        }


    }

</script>
